import React, { type FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { VoteSubmitDtoStatusEnum } from '../types/generated'

/**
 * Component that displays translated vote status text
 */
export const VoteStatusText: FC<{ status: VoteSubmitDtoStatusEnum }> = ({
  status,
}) => {
  switch (status) {
    case VoteSubmitDtoStatusEnum.RECEIVED:
      return (
        <FormattedMessage id="voteStatus.received" defaultMessage="Получено" />
      )
    case VoteSubmitDtoStatusEnum.PROCESSING:
      return (
        <FormattedMessage
          id="voteStatus.processing"
          defaultMessage="В обработке"
        />
      )
    case VoteSubmitDtoStatusEnum.INITIAL_FAILED:
      return (
        <FormattedMessage
          id="voteStatus.initialFailed"
          defaultMessage="Ошибка транзакции"
        />
      )
    case VoteSubmitDtoStatusEnum.CHILD_FAILED:
      return (
        <FormattedMessage
          id="voteStatus.childFailed"
          defaultMessage="Ошибка обработки"
        />
      )
    case VoteSubmitDtoStatusEnum.ACCEPTED:
      return (
        <FormattedMessage
          id="voteStatus.accepted"
          defaultMessage="Подтверждено"
        />
      )
    case VoteSubmitDtoStatusEnum.NOT_FOUND:
      return (
        <FormattedMessage
          id="voteStatus.notFound"
          defaultMessage="Не найдено"
        />
      )
    default:
      return <>{status}</>
  }
}
